module.exports = __webpack_public_path__ + "static/index/img/baikal-304.1ddb8ec9.jpg";